<template>
  <div class="alert-container" :class="{'active': active}">
    <div class="alert" :class="[level, active ? 'active' : '']">
      <div class="alert-wrapper">
        <span class="icon alert-icon" :class="level">
          <svg width="28px" height="28px" viewBox="0 0 28 28"><use :xlink:href="'/static/sprites.svg#glyph-medium-alert-' + level"></use></svg>
        </span>

        <div class="alert-content">
          <div class="alert-title">{{title}}</div>
          <div v-if="subtitle && isHtml" class="alert-subtitle" v-html="subtitle">{{subtitle}}</div>
          <div v-if="subtitle && !isHtml" class="alert-subtitle">{{subtitle}}</div>
        </div>

        <a href="javascript:;" @click="closeMe()" class="alert-close"><span>Lukk</span> <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheLoader',
  computed: {
    level () {
      return this.$store.getters.alertLevel
    },
    title () {
      return this.$store.getters.alertTitle
    },
    subtitle () {
      return this.$store.getters.alertSubtitle
    },
    active () {
      return !!this.$store.getters.alertActive
    },
    isHtml () {
      return !!this.$store.getters.alertIsHtml
    }
  },
  methods: {
    closeMe: function () {
      this.$helpers.hideAlert()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/TheAlert.vue